module.exports = __webpack_public_path__ + "img/loader.a679867a.gif";